/**
 * @function width
 * @description Get the viewport width.
 */

export const width = () => {
	const a = document.clientWidth;
	const b = window.innerWidth;
	return a < b ? b : a;
};

/**
 * @function height
 * @description Get the viewport height.
 */

export const height = () => {
	const a = document.clientHeight;
	const b = window.clientHeight;
	return a < b ? b : a;
};
